module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114139_104_157.51227db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114139_104_157.jpg
// module id = /16m
// module chunks = 0